import React from 'react'
import categories from './BuildingBlocks.json'
import { Link } from 'react-router-dom'

export const BuildingBlocksLeft = ({ containerObject, templateName, contentId, dataZone }) => {
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={` ${containerObject.attributes.articleContainerRendering} ${containerObject.attributes.class} vast-plugin-content row g-0 mb-2`}>
            <div class="building-tab">
                <div class="building-tabs">
                    <div className="nav d-none d-md-flex">
                        <h2 class="building-sidepanel-heading">Building Blocks of Science</h2>
                    </div>
                </div>
            </div>
            <div className=" row mt-1">
                <div className="col-12">
                    <ul className="list-group">
                        {categories && categories.buildingBlocks.map((value, key) => {
                            return (
                                <li className="col-lg-12 col-md-12 list-group-item mt-0">
                                    <Link to={value && value.buildingBlocksUrl} class="list-group-action"> {value.buildingBlocksName} <span class="list-icon"><i class='fas fa-caret-right'ss></i></span> </Link>
                                </li>

                            )
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}
